import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { Evaluation, ChildDetail } from '@/hooks/use-parent-data';
import { EvaluationCard } from '@/components/shared/evaluation-scores-grid';
import { EmptyState } from '@/components/shared/empty-state';

interface EvaluationsTabProps {
  evaluations: Evaluation[];
  averages: ChildDetail['stats']['evalAverages'];
}

export function EvaluationsTab({ evaluations, averages }: EvaluationsTabProps) {
  if (evaluations.length === 0) {
    return (
      <Card>
        <CardContent className="p-6">
          <EmptyState title="No evaluations recorded yet." />
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {/* Averages Card */}
      {averages && (
        <Card>
          <CardHeader>
            <CardTitle>Overall Averages</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {Object.entries(averages).filter(([, v]) => v != null).map(([key, value]) => (
                <div key={key} className="text-center p-3 bg-muted/40 rounded-lg">
                  <p className="text-2xl font-bold text-foreground">{value}</p>
                  <p className="text-sm text-muted-foreground capitalize">
                    {key.replace(/([A-Z])/g, ' $1').trim()}
                  </p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Evaluation List */}
      <Card>
        <CardHeader>
          <CardTitle>Evaluation History</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {evaluations.map(eval_ => (
              <EvaluationCard key={eval_.id} evaluation={eval_} size="md" />
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
